import { alpha, styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import { DataGridPro } from '@mui/x-data-grid-pro';

export const MasterDetailRoot = styled('div')(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  overflow: 'hidden',
}));

export const MasterDetailDataGrid = styled(DataGridPro)(({ theme }) => ({
  border: 'none',
  borderRadius: 0,
  width: '100%',
  backgroundColor: theme.palette.common.white,
  '--DataGrid-rowBorderColor': theme.palette.divider,
  '& .MuiDataGrid-columnHeaders': {
    minHeight: '48px !important',
    maxHeight: '48px !important',
    backgroundColor: 'transparent',
    borderBottom: 'none',
  },
  '& .MuiDataGrid-columnHeader': {
    padding: theme.spacing(1.75, 1),
    backgroundColor: alpha(theme.palette.primary.main, 0.04),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    ...theme.typography['label-small'],
    color: theme.palette.text.primary,
    whiteSpace: 'nowrap',
  },
  '& .MuiDataGrid-columnHeader--last': {
    padding: theme.spacing(1.75, 0.5),
  },
  '& .MuiDataGrid-row': {
    minHeight: '48px !important',
    maxHeight: '48px !important',
    backgroundColor: theme.palette.primary.contrastText,
  },
  '& .MuiDataGrid-cell': {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1.75, 1),
    ...theme.typography['body-small'],
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.primary.contrastText,
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  },
  '& .MuiDataGrid-cell.expand-toggle-cell': {
    padding: theme.spacing(1.75, 0.5),
    justifyContent: 'flex-end',
  },
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-footerContainer': {
    display: 'none',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-detailPanel': {
    backgroundColor: theme.palette.background.paper,
  },
})) as typeof DataGridPro;

export const MasterDetailExpandButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.action.active,
}));
